export default function decodeToken(token) {
  const tokenFragment = token.split('.')[1];
  const replacedTokenFragment = tokenFragment.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(atob(replacedTokenFragment).split('')
    .map((c) => `%${(`00${c.charCodeAt(0).toString(16)}`).slice(-2)}`).join(''));
  return JSON.parse(jsonPayload);
}
